import { Organization, User } from '@/shared/types/userTypes';
import { CustomerUsersSection } from '@/domains/customers/components/tabs/CustomerUsersSection';
import { Customer } from '@/shared/types/customerTypes';
import { Bell, Users } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/shared/ui/tabs';
import { cn } from '@/shared/utils/date-utils';
import { NotificationsSection } from '@/domains/accounts/components/tabs/settings-sections/NotificationsSection';
import { useUserRoles } from '@/shared/hooks/userRoles';

interface CustomerSettingsTabProps {
  customer: Customer;
  currentUser: User;
  selectedOrganization: Organization;
}

export const CustomerSettingsTab = ({ customer, currentUser, selectedOrganization }: CustomerSettingsTabProps) => {
  const { isCustomerUser } = useUserRoles();

  const canAccessNotifications = false; //isCustomerUser && selectedOrganization.isNotificationAllowed === true;
  const tabCount = canAccessNotifications ? 2 : 1;

  return (
    <div className="space-y-4">
      <Tabs defaultValue="users" className="flex flex-col space-y-4">
        <TabsList
          className={cn(
            'grid w-full max-w-xl shrink-0 justify-center mx-auto',
            tabCount === 2 ? 'grid-cols-2' : 'grid-cols-1',
            tabCount === 1 && 'hidden',
          )}
        >
          <TabsTrigger
            value="users"
            className="data-[state=active]:bg-foreground data-[state=active]:text-background flex items-center gap-2 justify-center"
          >
            <Users className="h-4 w-4" />
            Users
          </TabsTrigger>
        </TabsList>

        {canAccessNotifications && (
          <TabsTrigger
            value="notifications"
            className="data-[state=active]:bg-foreground data-[state=active]:text-background flex items-center gap-2 justify-center"
          >
            <Bell className="h-4 w-4" />
            Notifications
          </TabsTrigger>
        )}

        <TabsContent value="users">
          <CustomerUsersSection customer={customer} currentUser={currentUser} />
        </TabsContent>

        {canAccessNotifications && (
          <TabsContent value="notifications">
            <NotificationsSection />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
}